import React, { useEffect, useRef, useState } from "react";
import RichText from "components/rich-text";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const Faq = ({ data }) => {
  const tabList = useRef(null);
  const [selectedTab, setSelectedTab] = useState(0);

  const components = {
    normal: ({ children }) => (
      <p className="paragraph-normal text-gray-700 mb-3">{children}</p>
    ),
  };

  return (
    <div className="">
      <div className="container">
        <div className="text-center">
          <h4 className="paragraph-normal text-green-800">FAQ</h4>
          <h2 className="font-display font-bold text-h2 text-green-800 mt-2 mb-6">
            {data.title}
          </h2>
          <p className="paragraph-normal text-green-800">{data.description}</p>
        </div>
        <div className="mt-16 overflow-hidden">
          <Tabs onSelect={(index) => setSelectedTab(index)}>
            <div className="sm:overflow-x-auto w-full no-scrollbar py-1 mb-16 sm:mb-12">
              <div
                ref={tabList}
                className="sm:justify-center sm:w-fit sm:mx-auto"
              >
                <TabList className="tab-list flex justify-center items-center gap-8 md:gap-7">
                  {data.faqTab.map(({ tab }, index) => (
                    <Tab
                      className={`paragraph text-gray-800 opacity-60 cursor-pointer ${
                        selectedTab == index
                          ? "opacity-100 !font-bold border-solid border-0 border-b-[3px] border-[#0F43F9]"
                          : ""
                      }`}
                      key={index}
                    >
                      <div className="inline-flex whitespace-nowrap">{tab}</div>
                    </Tab>
                  ))}
                </TabList>
              </div>
            </div>

            {data.faqTab.map((tab, index) => (
              <TabPanel
                className="grid grid-cols-2 gap-14 sm:grid-cols-1"
                key={index}
              >
                <React.Fragment key={index}>
                  {tab?.questions.map(({ question, answer }, i) => (
                    <div key={`${index} + ${i}`}>
                      <h3 className="paragraph-lg-bold color-gray-900 mb-3">
                        {i + 1}.{question}
                      </h3>
                      <div>
                        <RichText value={answer.data} components={components} />
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              </TabPanel>
            ))}
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Faq;
